<!--

The action toolbar for the regular Edit editor page.

Let's user's do things like email Edit's out, make share links, and view as a preview or PDF

-->
<template>
  <div
    class="actions-bar__container"
    :class="isIPad ? 'actions-bar__container--ipad' : ''"
  >
    <div
      ref="actionBar"
      class="actions-bar"
    >
      <base-tooltip
        :offset="[-30, 19]"
        class="tooltip-publish"
      >
        <template slot="tooltip">
          <slot name="tooltip">
            <p class="header-tooltip">
              {{ toggleToPublished ? 'Public' : 'Private' }}
            </p>
            <p class="body-tooltip">
              {{ toggleToPublished? 'Your colleagues can view your edit in the explore section.' : 'Your edit will not be visible in the explore section.' }}
            </p>
          </slot>
        </template>
        <div v-if="hasPermissionPublish" class="d-flex justify-content-start align-items-center toggle-to-publish">
          <base-switch
            class="switch-publish"
            :value="toggleToPublished"
            :disabled="disabled"
            @input="onTogglePublish"
          />
          <base-text class="permission-title">
            Public
          </base-text>
        </div>
      </base-tooltip>
      <div class="d-flex align-items-center mb-4 ml--2">
        <base-button
          :disabled="disabled || disableEmailPdf"
          class="custombutton"
          :class="isIPad ? 'custombutton--ipad' : ''"
          borderless
          @click="linkActionPDF"
        >
          <base-icon icon="save-pdf" /> {{ $t('outreach.detail.actions.pdf') }}
        </base-button>
        <!-- create link -->
        <base-tooltip
          v-if="useToolTip()"
          :text="tooltipText"
        >
          <base-button
            :disabled="disabled"
            class="custombutton"
            :class="isIPad ? 'custombutton--ipad' : ''"
            borderless
            :style="`${isIPad ? 'width: 147px;' : ''}`"
            @click.native="linkEmbed"
          >
            <base-icon icon="embed-link" style="margin: unset;" /> {{ $t('outreach.detail.actions.embed') }}
          </base-button>
        </base-tooltip>
        <!-- end created link -->
        <base-button
          v-else
          :disabled="disabled"
          class="custombutton"
          :class="isIPad ? 'custombutton--ipad' : ''"
          borderless
          :style="`${isIPad ? 'width: 147px;' : ''}`"
          @click="linkEmbed"
        >
          <base-icon icon="embed-link" /> {{ $t('outreach.detail.actions.embed') }}
        </base-button>
        <!-- messaging -->
        <div
          v-click-outside="messaging"
          style="position: relative; margin-right: 1px !important;"
        >
          <base-button
            :disabled="disabled"
            class="custombutton messaging-button m-0"
            :class="isIPad ? 'custombutton--ipad' : ''"
            borderless
            nowrap
            @click.native="toggleMessagingPopup"
          >
            <base-icon icon="chat" />
            {{ $t('outreach.detail.actions.message') }}
            <base-icon
              :icon="messagingPopupOpen ? 'caret-up-black' : 'caret-down-black'"
              style="margin-left: 11px !important;"
            />
          </base-button>
          <transition name="fade">
            <div
              v-if="messagingPopupOpen"
              class="schedule-popup-container"
              :class="{ 'schedule-popup-container--ipad': isIPad}"
            >
              <div class="btn-group btn-messaging">
                <base-button
                  :disabled="disabled"
                  class="custombutton schedule-button mx-0"
                  borderless
                  nowrap
                  @click.native="linkURL"
                >
                  <base-icon icon="chain-link" /> {{ $t('outreach.detail.actions.link') }}
                </base-button>
                <base-button
                  :disabled="disabled"
                  class="custombutton sendtest-button mx-0"
                  borderless
                  nowrap
                  @click.native="linkWechat"
                >
                  <base-icon icon="wechatQR-link" /> {{ $t('outreach.detail.actions.weChat') }}
                </base-button>
              </div>
            </div>
          </transition>
        </div>
        <!-- end messaging -->
        <!-- delete vr sparator -->
        <base-button
          :disabled="disabled "
          class="custombutton sendbuttons"
          :class="
            isIPad
              ? 'sendmargins sendcustombutton custombutton--ipad'
              : 'sendmargins'
          "
          borderless
          inverse
          nowrap
          @click.native="prompt_email()"
        >
          <template v-if="emailEngine.status == 'sending'">
            <font-awesome-icon
              :icon="['fas', 'spinner']"
              spin
              class="mr-2"
            /> {{ $t('outreach.detail.actions.sending') }}
            {{ emailEngine.name }}
          </template>
          <template v-else>
            <base-icon v-if="emailEngine.name == 'Outlook'" icon="send-outlook" />
            <base-icon v-else-if="emailEngine.name == 'Gmail'" icon="send-gmail" />
            <base-icon v-else icon="send-email" />
            {{ $t('outreach.detail.actions.send') }}
            {{ emailEngine.name }}
          </template>
        </base-button>
        <!-- schecule email -->
        <div
          id="caret-send-email"
          v-click-outside="closeSchedulePopup"
          :style="`${isIPad ? 'height: 37px' : ''}`"
        >
          <base-button
            :disabled="disabled"
            class="schedulemargins m-0 caretButton"
            borderless
            inverse
            nowrap
            @click.native="toggleSchedulePopup"
          >
            <base-icon :icon="schedulePopupOpen ? 'caret-up-white' : 'caret-down-white'" />
          </base-button>
          <transition name="fade">
            <div
              v-if="schedulePopupOpen"
              class="schedule-popup-container"
              :class="{ 'schedule-popup-container--ipad': isIPad}"
            >
              <div
                class="btn-group btn-email"
                :class="{ 'btn-email--ipad': isIPad}"
              >
                <base-button
                  :disabled="disabled"
                  class="custombutton schedule-button mx-0"
                  borderless
                  nowrap
                  @click.native="prompt_test()"
                >
                  <base-icon icon="send-test" /> {{ $t('outreach.detail.actions.test') }}
                </base-button>
                <base-button
                  :disabled="disabled"
                  class="custombutton sendtest-button mx-0"
                  borderless
                  nowrap
                  @click.native="showScheduleModal"
                >
                  <base-icon icon="schedule-send" /> {{ $t('outreach.detail.actions.schedule') }}
                </base-button>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <validation-observer
        ref="form"
        v-slot="{ invalid }"
        style="display: none;"
      >
        <base-confirm-dialog-extended
          class="modalSendTest"
          :show="confirm_test === true"
          title="Send test to:"
          message=""
          positive-text="Send"
          :disabled="invalid"
          @confirmed="send_test()"
          @cancelled="confirm_test = false"
        >
          <form
            data-vv-scope="test-form"
            class="needs-validation test-form-margin"
            novalidate
          >
            <div class="mb-3">
              <!-- First Name: -->
              <validation-provider
                ref="test_first_name_provider"
                v-slot="{ invalid }"
                name="name"
                rules=""
              >
                <input
                  ref="test_first_name"
                  v-model="test_first_name"
                  type="text"
                  :class="`form-control ${invalid ? 'is-invalid' : ''}`"
                  name="test_first_name"
                >
              </validation-provider>
            </div>
            <div class="mb-3">
              <!-- Email: -->
              <validation-provider
                ref="test_email_provider"
                v-slot="{ invalid }"
                name="email"
                rules="required|email"
              >
                <input
                  ref="test_email"
                  v-model="test_email"
                  type="email"
                  :class="`form-control ${invalid && !onFocus ? 'is-invalid' : ''}`"
                  name="test_email"
                  @focus="onFocus = true"
                  @blur="onFocus = false"
                >
                <span
                  class="caption-regular text-error"
                  style="margin-top: 6px; justify-content: start; display: flex;"
                >
                  {{ !onFocus && invalid ? ' Please enter a valid email' : '' }}
                </span>
              </validation-provider>
            </div>
          </form>
        </base-confirm-dialog-extended>
      </validation-observer>

      <base-confirm-dialog
        :show="confirm_email"
        message="Are you sure you want to send?"
        positive-text="Send"
        @confirmed="sendMail()"
        @cancelled="confirm_email = false"
      />

      <base-confirm-dialog-extended
        title="Done!"
        :show="
          $store.state.entries.emailStatus == 'sent' ||
            $store.state.entries.gmailStatus == 'sent' ||
            $store.state.entries.outlookStatus == 'sent'
        "
        :message="scheduledTime ? emailConfirmScheduleTime() : emailSentConfirmDialogText()"
        :show-cancel="false"
        positive-text="View report"
        @confirmed="updateStatus(`/entries/${item.pk}/sent`)"
        @closed="updateStatus(`/entries/${item.pk}/sent`)"
      />

      <base-confirm-dialog
        :show="
          $store.state.entries.emailStatus == 'sent_test' ||
            $store.state.entries.gmailStatus == 'sent_test' ||
            $store.state.entries.outlookStatus == 'sent_test'
        "
        message="Your test email was sent"
        :show-close-button="false"
        :show-cancel="false"
        @confirmed="updateStatus()"
      />

      <base-confirm-dialog
        :show="
          $store.state.entries.emailStatus == 'error' ||
            $store.state.entries.gmailStatus == 'error' ||
            $store.state.entries.outlookStatus == 'error'
        "
        :message="
          $store.state.entries.emailStatusMessage ||
            'There was an error sending your email. Please try again.'
        "
        :show-actions="!$store.state.entries.emailStatusMessage"
        :show-close-button="$store.state.entries.emailStatusMessage"
        positive-text="Send another edit"
        @cancelled="updateStatus()"
        @confirmed="updateStatus('/entries')"
      />
      <link-creation-modal
        v-if="item.pk"
        ref="linkCreationModal"
        style="display: none;"
        :show="linkModal"
        :edit="item.pk"
        :display="linkFormat"
        :message="methodMessage"
        @close-link-modal="onCloseLinkModal()"
        @old-link-method="copyLink($event)"
        @old-pdf-method="viewPDF($event)"
      />
      <schedule-email-modal
        v-if="item.pk"
        ref="scheduleEmailModal"
        style="display: none;"
        :show="scheduleModal"
        :edit="item.pk"
        @close-schedule-modal="scheduleModal = false"
        @schedule-email="scheduleEmail"
      />
      <!-- <base-modal id="copyLink" title="Link created!">
      <input
        ref="link"
        type="text"
        :value="link"
        style="opacity: 1"
      >
    </base-modal> -->
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { EventBus } from '@/event-bus';
import { entryService, linksService } from '@/_services';
import Whichbrowser from '@/components/mixins/whichbrowser';
import emailEngine from '@/components/mixins/emailEngine';
import LinkCreationModal from './LinkCreationModal';

export default {
  name: 'Actions',
  components: {
    LinkCreationModal,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [Whichbrowser, emailEngine],
  props: {
    recipientsCount: {
      type: Number,
      default: 0,
    },
    toggleToPublished: {
      type: Boolean,
      default: true,
    },
    hasPermissionPublish: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      confirm_email: false,
      confirm_test: false,
      test_first_name: null,
      test_email: null,
      tooltipText: 'Copy to clipboard',
      linkModal: false,
      linkFormat: undefined,
      methodMessage: '',
      link: '',
      hero: '',
      title: '',
      schedulePopupOpen: false,
      messagingPopupOpen: false,
      scheduleModal: false,
      scheduledTime: null,
      recipientHtml: '',
      onFocus: false,
    };
  },
  computed: {
    item() {
      return this.$store.state.entries.item;
    },
    disabled() {
      return (
        this.$store.state.sections.isLoading
        || ['saving', 'loading'].includes(this.patchStatus)
      );
    },
    patchStatus() {
      return this.$store.state.entries.status;
    },
    profileEmail() {
      return this.$store.state.account.user.user.email;
    },
    disableEmailPdf() {
      return this.useFeature('disable_email_pdf');
    },
    // eslint-disable-next-line vue/no-dupe-keys
    toggleToPublished() {
      return this.item.published;
    },
  },
  created() {
    this.hasPermissionPublish = this.getFeature('published_toggle');
  },
  methods: {
    onTogglePublish(val) {
      this.item.published = val;
      this.$store.dispatch('entries/editPublished', (this.item)).then((data) => {
        this.toggleToPublished = data.published;
      });
    },
    preview() {
      this.$mixpanel.track('preview', {
        account_id: this.$store.state.account.user.user.email,
        edit: this.$route.params.id,
      });
      this.$router.push({ name: 'PageEditorPreview' });
    },
    viewPDF(fromLinkCreation = false) {
      // const new_url = 'https://us-central1-html2pdf-256812.cloudfunctions.net/http/535/';
      this.$mixpanel.track('view_pdf', {
        account_id: this.$store.state.account.user.user.email,
        edit: this.$route.params.id,
      });

      const link = document.createElement('a'); // We have to create the new dom object before excecute the async function

      linksService.createLink(this.item.pk, 'pdf').then((response) => {
        const { url } = response.data;

        try {
          link.href = url;
          link.download = 'file.pdf';
          link.dispatchEvent(new MouseEvent('click'));
          if (fromLinkCreation) {
            this.$nextTick().then(() => {
              this.$refs.linkCreationModal.showSuccessModal();
            });
          }
        } catch (e) {
          EventBus.$emit(
            'toast-error',
            'Couldn\'t copy link, please wait a few seconds and try again.',
          );
        }
        setTimeout(() => {
          this.tooltipText = 'Copy to clipboard';
        }, 30000);
      });
    },
    async getRecipientHtml() {
      const recipients = (await entryService.getEditRecipients(this.$route.params.id)).data;
      if (recipients.customers.length === 0) {
        return null;
      }
      const lines = [];
      if (this.$store.state.entries.item.to_groups > 1) {
        lines.push(`${this.$store.state.entries.item.to_groups.length} Groups`);
      } else {
        lines.push(...this.$store.state.entries.item.to_groups.map((group) => `${group.name} (${group.member_count || 0})`));
      }
      if (this.$store.state.entries.item.to_customers > 1) {
        lines.push(`${this.$store.state.entries.item.to_customers.length} Clients`);
      } else {
        lines.push(...this.$store.state.entries.item.to_customers.map((customer) => `<u style="font-family: 'SilkaMedium'; margin-top:1rem;">${customer.email}</u>`));
      }
      lines.push(`<b style="font-family: 'SilkaMedium';font-weight:500; ">${recipients.customers.length} Opted-In<b>`);
      return lines.map((line) => `<p style="margin-top: -8px;"></p>${line}`).join('');
    },
    async prompt_email() {
      this.recipientHtml = await this.getRecipientHtml();
      if (this.recipientHtml !== null) {
        EventBus.$emit('confirm', {
          title: 'Are you sure want to?',
          message: `You are about to send an edit to:${this.recipientHtml}`,
          positiveText: 'Send',
          showCloseButton: true,
          callback: (confirm) => {
            if (confirm) {
              this.$refs.actionBar.click();
              this.sendMail();
            }
          },
        });
      } else {
        EventBus.$emit('confirm', {
          title: 'Error',
          message: 'Please specify at least one recipient with a valid email.',
          positiveText: 'OK',
          showCancel: true,
          showCloseButton: false,
        });
      }
    },
    prompt_test() {
      if (!this.test_email || !this.test_email.length) {
        this.test_email = this.$store.state.account.user.user.email;
        this.test_first_name = this.$store.state.account.user.user.first_name;
      }
      this.confirm_test = true;
    },
    sendMail() {
      this.confirm_email = false;
      return this.emailEngine.action();
    },
    showScheduleModal() {
      if (this.recipientsCount === 0) {
        EventBus.$emit('confirm', {
          title: 'Error',
          message: 'Please specify at least one recipient.',
          positiveText: 'OK',
          showCancel: true,
          showCloseButton: false,
        });
        return;
      }
      this.scheduleModal = true;
    },
    scheduleEmail(scheduled) {
      this.scheduledTime = scheduled;
      this.scheduleModal = false;
      this.closeSchedulePopup();

      this.emailEngine.scheduledTime = scheduled;
      this.sendMail();
    },
    messaging() {
      this.closeMessagingPopup();
    },
    updateStatus(route) {
      // Resets store
      this.$store.commit('entries/updateEmailStatus', null, null);
      this.$store.commit('entries/updateOutlookStatus', null, null);
      this.$store.commit('entries/updateGmailStatus', null, null);
      this.$store.commit('entries/updateEmailStatusMessage', null, null);

      // Redirects if the route is set. This needs to happen after :show change
      if (route) {
        this.$nextTick().then(() => {
          this.$router.push(route);
        });
      }
    },
    useToolTip() {
      return !this.useFeature('targeted_create_link');
    },
    linkAction() {
      if (this.useFeature('targeted_create_link')) {
        this.linkFormat = 'html';
        this.openLinkModal();
      } else {
        this.copyLink();
      }
    },
    linkWechat() {
      if (this.useFeature('targeted_create_link')) {
        this.linkFormat = 'html';
        this.methodMessage = 1;
        this.openLinkModal();
      } else {
        this.copyLink();
      }
    },
    linkURL() {
      if (this.useFeature('targeted_create_link')) {
        this.linkFormat = 'html';
        this.methodMessage = 0;
        this.openLinkModal();
      } else {
        this.copyLink();
      }
    },
    linkEmbed() {
      if (this.useFeature('targeted_create_link')) {
        this.linkFormat = 'html';
        this.methodMessage = 2;
        this.openLinkModal();
      } else {
        this.copyLink();
      }
    },
    linkActionPDF() {
      if (this.useFeature('targeted_create_link')) {
        this.linkFormat = 'pdf';
        this.methodMessage = 0;
        this.openLinkModal();
      } else {
        this.viewPDF();
      }
    },
    copyLink(fromLinkCreation = false) {
      this.$mixpanel.track('copy_link', {
        account_id: this.$store.state.account.user.user.email,
        edit: this.$route.params.id,
      });

      linksService.createLink(this.item.pk, 'html').then((response) => {
        const { url, hero, title } = response.data;
        this.link = url;
        this.hero = hero;
        this.title = title;
        /* Safari requires an user action in order to copy to the clipboard.
         */
        // Fallback
        if (this.browserClass === 'is-safari') {
          EventBus.$emit('confirm', {
            title: 'Link created!',
            message: `<input type="text" id="copyLinkInput" value="${url}" />`,
            showOptions: false,
            customClass: 'copy-link-fallback',
          });
          setTimeout(() => {
            const input = document.querySelector('#copyLinkInput');
            input.focus();
            input.addEventListener('blur', () => {
              input.select();
              input.setSelectionRange(0, 99999); /* For mobile devices */
              document.execCommand('copy');
            });
          }, 1000);
        }
        try {
          window.Clipboard.copy(url);
          this.tooltipText = 'Copied!';
        } catch (e) {
          this.tooltipText = 'Failed';
        }
        if (fromLinkCreation) {
          this.$nextTick().then(() => {
            this.$refs.linkCreationModal.testLinkCreated(
              this.link,
              this.hero,
              this.title,
            );
          });
        }
        setTimeout(() => {
          this.tooltipText = 'Copy to clipboard';
        }, 3000);
      });
    },
    openLinkModal() {
      this.linkModal = true;
    },
    onCloseLinkModal() {
      this.linkModal = false;
      EventBus.$emit('restart-recipients-customers');
    },
    toggleSchedulePopup() {
      this.schedulePopupOpen = !this.schedulePopupOpen;
      this.messagingPopupOpen = false;
    },
    closeSchedulePopup() {
      this.schedulePopupOpen = false;
    },
    toggleMessagingPopup() {
      this.messagingPopupOpen = !this.messagingPopupOpen;
      this.schedulePopupOpen = false;
    },
    closeMessagingPopup() {
      this.messagingPopupOpen = false;
    },
    stripHtml(html) {
      const tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    },
    emailSentConfirmDialogText() {
      return `${this.stripHtml(this.$store.state.entries.item.subject)} was sent to${this.recipientHtml}`;
    },
    emailConfirmScheduleTime() {
      return `Email is scheduled for ${this.scheduledTime.format(
        'MMMM Do[,] h:mm A',
      )}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.actions-bar__container {
  display: flex;
  width: 100%;
  max-width: 1100px;

  &--ipad {
    justify-content: start;
  }
}
.actions-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;

}
.custombutton {
  border: 1px solid #C6C6C6 !important;
  border-radius: 5px !important;
  font-size: 14px;
  padding: 10px 8px 10px 12px;
  border-radius: 5px !important;
  margin: unset !important;
  margin-right: 8px !important;
  width: 147px;
  height: 36px !important;
  font-family: 'SilkaRegular';

  &--ipad {
    border-radius: 8px;
    box-shadow: 0 0 14px 0px #33333311;
    font-size: 12px;
    padding-right: 22px;
  }

  &--ipad > img {
    margin-right: 10px !important;
  }
  img {
   margin-left: 0px !important;
   margin-right: 9px !important;
  }
}
.caretButton{
  border-radius: 0px 5px 5px 0px !important;
  padding: 10px 15px 10px 8px;
  border-radius: 5px;
  height: 36px !important;

}
.lastcustombutton {
  margin-right: 6px;
}
.sendcustombutton {
  margin-left: 6px;
  padding-left: 14px;
}
.sendbuttons{
  border-radius: 5px 0px 0px 5px !important;
  border: unset !important;
  margin-left:15px;
  margin-right: 1px !important;
}
.sendmargins {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-right: 1px;
}
.schedulemargins {
  height: 100%;
  width: 21px;
  padding-left: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.schedule-popup-container {
  z-index: 100;
  position: absolute;
  top: calc(100% + 2px);

  &--ipad {
    width: 175px;
  }
}
.messaging-button{
  max-width: 148px;
}
.btn-email {
  min-width: 200px;
  box-shadow: 0px 12px 12px -6px rgba(51, 51, 51, 0.16);
  border-radius: 4px;
  right: 70%;

  &--ipad {
    right: calc(80% + 4px);
  }
}
.btn-messaging {
  min-width: 200px;
  box-shadow: 0px 12px 12px -6px rgba(51, 51, 51, 0.16);
  border-radius: 4px;
  right: 0;

}
.schedule-button{
  width: 100%;
  // box-shadow: 0px 0px 10px rgba(51, 51, 51, 0.15);
}
.messaging-button{
  max-width: 148px;
}
.sendtest-button {
  width: 100%;
  // box-shadow: 0px 0px 10px rgba(51, 51, 51, 0.15);
}
.custombutton:not(.base-button--inverse) {
  color: $black;
}
.custombutton > img {
  margin-left: 8px;
  margin-right: 8px;
}
.custombutton:hover {
  background-color: #f0f0f0;
}

.schedulemargins > .base-icon {
  margin: 0 !important;
  padding-inline: 0 !important;
}
</style>
<style>
.copy-link-fallback .modal-dialog {
  width: 620px !important;
  transform: translateY(calc(-50%)) !important;
}
.copy-link-fallback .modal-dialog input[type="text"] {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #d4d4d4;
  height: 36px;
  padding: 1rem;
}
/* .toggle-to-publish {
  padding-bottom: 12px;
  padding-right: 14px;
} */
.switch-publish {
  height: 22px !important;
}
.permission-title{
  font-family: 'SilkaLight';
  font-style: normal;
  font-size: 14px;
  line-height: 17px;
  padding-left: 8px;
}
.base-switch{
  height: 20px;
}
.tooltip-publish{
  margin-top:7px;
}
.header-tooltip{
  font-family: 'SilkaMedium';
  font-style: normal;
  text-align:center;
  font-size:14px;
  margin-bottom:unset;
  margin-top:5px;
}
.body-tooltip{
  font-family: 'SilkaLight';
  font-style: normal;
  font-weight: 300 !important;
  text-align:center;
  max-width:200px;
  margin-top:4px;
  margin-bottom:5px;
  font-size:12px;
  padding-left: 4px;
  padding-right:4px;
}
.btn-group{
  background: white;
  padding-top: 4px;
  padding-bottom: 4px;
  cursor: pointer;
  display: block;
}
.btn-group   .base-button {
  border: none ! important;
  border-radius: 0 !important;
}
#caret-send-email{
  height: 36px;
  position: relative;
}
.test-form-margin{
  margin-top: -10px;
  margin-left: -7px;
  margin-right: -7px;
}
.modalSendTest .message{
    padding: 30px !important;
}
.modalDone{
  padding: 100px;
}
</style>
